import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiValidationService } from '@rd/core/services/api-validation/api-validation.service';
import { NydusNetworkApiDataService } from '@rd/core/services/nydus-network-api-data/nydus-network-api-data.service';
import { pointsAccountResponseSchema } from '@rd/schemas/points-account.schema';
import { PointsAccountResponse } from '@rd/types/points-account.response';
import { PointsAccount } from '@rd/types/points-account.type';
import { TrancheModel } from '@rd/types/tranche.model';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { LoadPointsAccountsPayload } from '../../store/actions';

@Injectable()
export class PointsAccountApiService {
  private nydusNetworkDataService = inject(NydusNetworkApiDataService);
  private apiValidationService = inject(ApiValidationService);

  getPointsAccounts(
    payload: LoadPointsAccountsPayload,
  ): Observable<PointsAccount[]> {
    const pointsAccountsParams = this.buildPointsAccountsParams(
      payload.includeClosingPointsAccounts,
    );

    return this.nydusNetworkDataService
      .get<PointsAccountResponse>('points_accounts', pointsAccountsParams)
      .pipe(
        tap((response) => {
          this.apiValidationService.validate<PointsAccountResponse>({
            apiName: `points_accounts?${pointsAccountsParams.toString()}`,
            schema: pointsAccountResponseSchema,
            response,
          });
        }),
        map((response) => this.transformGetPointsAccountResponse(response)),
      );
  }

  private buildPointsAccountsParams(
    includeClosingPointsAccounts: boolean,
  ): HttpParams {
    const params = new HttpParams().set(
      'active',
      includeClosingPointsAccounts ? 'false' : 'true',
    );

    return params;
  }

  private transformGetPointsAccountResponse(
    response: PointsAccountResponse,
  ): PointsAccount[] {
    return response.data.map((res) => ({
      ...res.attributes,
      tranches: res.attributes.tranches.map((tranche: TrancheModel) => ({
        balance: tranche.balance,
        expiryDate: new Date(tranche.expiryDate),
      })),
    }));
  }
}
